import React from 'react';

import './styles/privileges.scss';

export const Privileges = (props) => {
    return (
        <div className="card-privileges">
            <h3>Включено в абонемент</h3>

            <p>Программа Умный старт / {props.privileges.smart_start}шт</p>
            <p>Персональная тренировка в тренажерном зале / {props.privileges.gym_personal_trains}шт</p>
            <p>Персональная тренировка в бассейне / {props.privileges.pool_personal_trains}шт</p>
            <p>Групповые тренировки от {props.privileges.count_group_trainings} уроков в день</p>
            <p>Гостевые визиты для друзей / {props.privileges.guest_visits}шт</p>
            <p>Teen-клуб 12+ гостевое / {props.privileges.teen_club_visits}шт</p>
            {props.privileges.loyalty_program ? <p>Программа лояльности</p> : ''}
            {props.privileges.personal_locker ? <p>Персональный шкафчик / сейфовая ячейка на время посещения</p> : ''}
            <p>Солярий {props.privileges.solarium_minutes} минут</p>
        </div>
    )
}